import { anonymousClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchInstitutions = async () => {
    return anonymousClient()
        .get(
            `/api/institutions`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve institutions`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchInstitutions,
}